const DELETED_STATUS = 'deleted';
const DELETED_USER_SLUG = 'deleted_user';

const isDeletedUser = (userData, statusField = 'status') => {
  return userData[statusField] === DELETED_STATUS;
};

const getUserName = (userData, intl, nameField = 'name', statusField = 'status') => {
  if (isDeletedUser(userData, statusField)) {
    return intl.formatMessage({ id: DELETED_USER_SLUG })
  }
  return userData[nameField];
};

export {
  isDeletedUser,
  getUserName,
  DELETED_USER_SLUG
}